import * as Common from '@tfo/common'
import { Loader } from '@tfo/common'
import { TfoCookie } from '@tfo/common/src/utils'
import LZstring from 'lz-string'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useStore } from '../../../../../hooks/useStore'

export const InitiateAtsOrder = observer(() => {
    const rootStore = useStore()
    const history = useHistory()

    const redirect = (CompanyId, companyIDsWithAccessArray, reportPackageId) => {
        let url = ''
        
				//This is turned-off feature for Teamtailor, reportPackageId will always be empty for now
        if (CompanyId && reportPackageId) {
            url = `/new-report-order/${CompanyId}/${reportPackageId}`
        }
        else if(companyIDsWithAccessArray.length > 1) {
            url = '/sub-companies'
        }
        else {
            url = `/service-packages/${companyIDsWithAccessArray[0]}`
        }

        history.push(url)
    }

    const setBodyInSessionStorage = (parsedBody: string) => {
        const JSONParsedBody = JSON.parse(parsedBody)
        window.sessionStorage.setItem('individualInformation', JSON.stringify(JSONParsedBody))
    }

    useEffect(() => {
        console.log("locations", {
            "window.location": window.location.search,
            "document.location": document.location.search,
            "window.frameElement.src": (window.frameElement as any)?.src || "not found"
        })
        const params = new URLSearchParams(window.location.search)
        const body = params.get('body')
        const parsedBody = LZstring.decompressFromBase64(body)
        const JSONParsedBody = JSON.parse(parsedBody)
        setBodyInSessionStorage(parsedBody)

        const { OrderData } = JSONParsedBody
        const reportPackageId = OrderData && OrderData.ReportPackageId

        const authToken = params.get('auth');
        rootStore.clientViewStore.toggleExternalHostedOrderFlow(true)
        const parsedAuthToken = authToken
            .split('.')[1]
            .replace('-', '+')
            .replace('_', '/')
        const { CompanyId, CompanyIDsWithAccess, UserId, Email, Name, Language, Roles } = JSON.parse(window.atob(parsedAuthToken))
        const FullName = Name.split(' ')
        const FirstName = FullName[0]
        const LastName = FullName[1]
        let parsedRoles = Roles
        if (typeof Roles === 'string') {
            try {
                parsedRoles = JSON.parse(Roles)
            } catch (error) {
                console.error("Failed to parse Roles:", error)
                parsedRoles = []
            }
        }
        const formattedRoles = Array.isArray(parsedRoles) ? parsedRoles.map((role: string) => ({ role })) : []

        const cookie: TfoCookie & { id: number } = {
            companyId: CompanyId,
            email: Email,
            firstName: FirstName,
            lastName: LastName,
            language: Language,
            lastActivity: new Date().toISOString(),
            token: authToken,
            userId: UserId,
            needToChangePasswordOnNextLogin: false,
            id: UserId,
            acceptedGeneralTerms: null,
            loginType: null,
            roles: formattedRoles
        }

        Common.utils.setCookie(JSON.stringify(cookie))
        const companyIDsWithAccessArray = JSON.parse(CompanyIDsWithAccess)

        rootStore.login()
            .then(() =>
                redirect(CompanyId, companyIDsWithAccessArray, reportPackageId)
            ).catch(console.error)
    }, [])

    return <Loader />
})
